exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-buttons[data-v-277d4e1a] {\n    display: flex;\n    align-items: flex-start;\n}\n.ml-auto[data-v-277d4e1a] {\n    margin-left: auto;\n}\n.add-button[data-v-277d4e1a] {\n    display: inline-block;\n}\n.add-days[data-v-277d4e1a] {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: flex-end;\n}\n\n", ""]);

// exports
